<script setup>
import { computed, watchEffect } from 'vue'
import PageHeader from './PageHeader.vue'
import SideNav from './SideNav.vue'
import { useWebAppStore } from '@/stores/webApp'
import { useNavigation } from '@/composables/useNavigation'
import { i18nService } from '@ecom/customer-common-front'

const webAppStore = useWebAppStore()
const { items, updateSelectedItem, selectedItemId, getRouteConfigByPath } = useNavigation()

watchEffect(() => {
  selectedItemId.value = getRouteConfigByPath()
})

const locale = computed(() => i18nService.getCurrentLocale())
const isLocaleDefined = computed(() => locale.value !== 'xx')
</script>

<template>
  <div class="page-layout">
    <PageHeader v-if="isLocaleDefined" />

    <div
      class="page-layout__content"
      :class="{
        'page-layout__content--hide-nav': !webAppStore.navIsDisplayed,
        'page-layout__content--container': !webAppStore.sideNavDisplayIsAllowed
      }"
    >
      <SideNav
        v-if="isLocaleDefined"
        v-model="selectedItemId"
        class="page-layout__nav"
        :items="items"
        @update:model-value="updateSelectedItem"
      />
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
.page-layout {
  &__content {
    display: grid;
    align-items: start;
    grid-template-columns: 320px 1fr;
  }

  .breadcrumb.home {
    display: block;
  }

  .dashboard-breadcrumb {
    display: none;
  }

  &__nav {
    border-right: 1px solid ccf.$color-stroke;
    top: 85px;
    position: sticky;
    display: block;
    height: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none; // IE 10+
    overflow: -moz-scrollbars-none; // Firefox
  }

  @include ccf.breakpoint('small') {
    grid-template-columns: 1fr;
    &__nav {
      display: none;
    }
    .breadcrumb.home {
      display: none;
    }

    .dashboard-breadcrumb {
      display: block;
    }
  }
}
</style>
